import React, { useEffect, useRef, useState } from 'react'
import ContentHeader from '../../../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import { useMutation, useQuery } from '@apollo/client'
import {
  GET_ONE_REPORT_BY_ID,
  UPDATE_REPORT,
} from '../../../../../../graphql/Catalog/Reports/reports'
import InputController from '../../../../../Global/InputController'
import Step1 from './steps/Step1'
import FormWizard from 'react-form-wizard-component'

const ModalEditReports = ({
  reportId,
  folio,
  refetchOrigin = () => {},
  setCloseModal = () => {},
}) => {
  // ------------- Hooks -----------
  const refWizard = useRef()
  const [loading, setLoading] = useState(true)
  const [isValidSteps, setIsValidSteps] = useState({
    step1: false,
  })
  const [isFinish, setIsFinish] = useState(false)

  const { showLoading, hideLoading } = useLoading()
  const [report, setReport] = useState({
    step1: {
      group_id: '',
      group_category_id: '',
      group_category_sub_id: '',
      address: null,
    },
  })

  // ------------- Queries -----------
  const {
    data: dataReport,
    loading: loadingReport,
    error: errorReport,
    refetch: refetchReport,
  } = useQuery(GET_ONE_REPORT_BY_ID, {
    variables: {
      reportId: Number(reportId),
    },
    fetchPolicy: 'no-cache',
  })

  // ------------- Mutations -----------
  const [UpdateReport] = useMutation(UPDATE_REPORT, {
    onCompleted: () => {
      hideLoading()
      handleClean()
      toastSweetAlert({
        mode: 'ok',
        message: 'El reporte se ha editado correctamente',
      })
      setCloseModal(true)
    },
    onError: (error) => {
      hideLoading()
      handleClean()
      return toastSweetAlert(
        { mode: 'error', message: error.message },
        setCloseModal(true)
      )
    },
  })
  // ------------- UseEffect -----------
  useEffect(() => {
    if (!loadingReport) {
      if (errorReport) {
        return toastSweetAlert({ mode: 'error', message: errorReport.message })
      }

      if (dataReport && dataReport?.getOneReportById) {
        const {
          group_id,
          group_category_id,
          group_category_sub_id,
          AddressOfReport,
          zone_id,
          ColonyOfReport,
        } = dataReport?.getOneReportById
        setReport({
          step1: {
            group_id: group_id || null,
            group_category_id: group_category_id || null,
            group_category_sub_id: group_category_sub_id || null,
            address_components: {
              address_full: AddressOfReport?.address_full || '',
              street: AddressOfReport?.street || '',
              colony: '',
              postalCode: parseInt(AddressOfReport?.zipcode) || null,
              state: AddressOfReport?.state || '',
              city: AddressOfReport?.city || '',
              country: '',
              latitude: AddressOfReport?.latitude || null,
              longitude: AddressOfReport?.longitude || null,
              url: AddressOfReport?.url_google_map || null,
              reference: AddressOfReport?.reference || '',
              zone_id: zone_id || null,
              colony_number: ColonyOfReport?.nocolonia || null,
              colony_name: ColonyOfReport?.name || null,
            },
          },
        })
      }
      setLoading(false)
    }
  }, [dataReport, loadingReport, errorReport])

  useEffect(() => {
    if (isFinish === true) {
      handleComplete()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinish])

  // ------------- Functions -----------
  const tabChanged = ({ prevIndex, nextIndex }) => {}

  const handleComplete = async () => {
    showLoading()
    try {
      //Prepare the data to be sent
      const { address, address_components } = report?.step1

      let input = {
        step1: {
          group_id: report.step1.group_id,
          group_category_id: report.step1.group_category_id,
          group_category_sub_id: report.step1.group_category_sub_id,
        },
      }

      if (!address_components?.zone_id)
        throw new Error('Faltan datos de la zona')

      input.step1.zone_id = address_components?.zone_id

      /* if (!address?.colony_number || !address?.colony_name) throw new Error('Faltan datos de la colonia') */
      input.step1.colony = {
        name: address_components?.colony_name,
        number: address_components?.colony_number,
      }
      input.step1.address = {
        street: address_components.street,
        zipcode: address_components.zipcode,
        state: address_components.state,
        city: address_components.city,
        reference: address_components?.reference,
        latitude: `${address_components.latitude}`,
        longitude: `${address_components.longitude}`,
        address_full: address_components.address_full,
        url_google_map: address_components.url,
      }
      await UpdateReport({
        variables: {
          reportId: Number(reportId),
          input,
        },
      })
    } catch (error) {
      hideLoading()
      return toastSweetAlert({ mode: 'error', message: error.message })
    }
  }

  const handleClean = () => {
    refetchOrigin()
    refetchReport()
    setIsFinish(false)
    setIsValidSteps({
      step1: false,
    })
  }

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12 col-sm-6">
            <h1 className="header-title">Editar reporte</h1>
          </div>
        }
        breadcrumb=""
        windowTitle={`Vista editar reporte`}
      />
      {loading ? (
        <></>
      ) : (
        <FormWizard
          ref={refWizard}
          shape="circle"
          color="#e74c3c"
          title={false}
          onComplete={handleComplete}
          onTabChange={tabChanged}
          backButtonTemplate={() => null}
          nextButtonTemplate={() => null}
          finishButtonTemplate={() => null}
          finishButtonText={() => null}
        >
          <FormWizard.TabContent title="Actualización basica" icon="fa fa-file">
            <Step1
              refWizard={refWizard}
              report={report?.step1}
              setReport={setReport}
              setIsValidSteps={setIsValidSteps}
              setIsFinish={setIsFinish}
            />
          </FormWizard.TabContent>
        </FormWizard>
      )}
    </>
  )
}

export default ModalEditReports
